// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"b69c30b6","78":"1434da71","227":"027ef1e6","463":"3767e321","488":"29b71886","735":"5353191f","954":"81d45c80"}[chunkId] + ".chunk.js";
};